import { render, staticRenderFns } from "./OrderDisplayView.vue?vue&type=template&id=13ec5a76&scoped=true"
import script from "./OrderDisplayView.vue?vue&type=script&lang=js"
export * from "./OrderDisplayView.vue?vue&type=script&lang=js"
import style0 from "./OrderDisplayView.vue?vue&type=style&index=0&id=13ec5a76&prod&scoped=true&lang=css"
import style1 from "./OrderDisplayView.vue?vue&type=style&index=1&id=13ec5a76&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ec5a76",
  null
  
)

export default component.exports